import React from 'react'
import Card from '../shared/card/card.jsx'
import root from '../shared/utils'
import {getOrdinalDate} from '../shared/enums/date-parser'
import {getTaskTypeIconParser} from '../shared/enums/task-type-icon-parser'

const JobAwaitingApproval = ({card, noPullDown, btnOnClick, numOfApprovalCards}) => {

  let taskTypeIcon = getTaskTypeIconParser(card.taskType)
  let midIconRoot = root + '/common/latest/images/consumer/status-icons/'
  let midIcon = midIconRoot + card.mobileJob.workFlowStep + '.png'
  let rightIcon = taskTypeIcon.iconsrc
  let img = null
  let date = getOrdinalDate(card.millisDate)
  let moduleType = card.moduleType
  if (card.photos.length !== 0) {
    img = card.photos[0].fullSizeUrl
  }
  let btnId = 'needApprovalCard' + numOfApprovalCards

  return (
    <Card
      headerTitle={card.header}
      heroImage={img}
      headerLeftIcon={card.date}
      headerMidIcon={midIcon}
      headerRightIcon={rightIcon}
      headerSubtitle={date}
      moduleType={moduleType}
      btnOnClick={btnOnClick}
      btnText='More Details'
      btnId={btnId}
      btnStyle='btn btn-sm btn-info'
      noPullDown={noPullDown}>
      <p dangerouslySetInnerHTML={{ __html: card.content }} />
    </Card>
  )
}

JobAwaitingApproval.propTypes = {
  card: React.PropTypes.object.isRequired,
  noPullDown: React.PropTypes.bool
}
export default JobAwaitingApproval



// WEBPACK FOOTER //
// ./src/components/dashboard/job-awaiting-approval.jsx